//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Base64 } from 'js-base64'
import { login, vercode, current_user } from '@/apis/user'
export default ({
	data() {
		//表單校驗
		const formDecorators = {
			username: ['username', { rules: [{ required: true, message: '請輸入您的賬戶名！' }] },],
			password: ['password', { rules: [{ required: true, message: '請輸入您的密碼！' }] },],
			vcode: ['vcode', { rules: [{ required: true, message: '請輸入驗證碼！' }] },]
		}
		return {
			// Binded model property for "Sign In Form" switch button for "Remember Me" .
			formDecorators,
			rememberMe: true,
			ver: {
				imageBase64Data: '',
				expireTime: 0
			}
		}
	},
	beforeCreate() {
		// Creates the form and adds to it component's "form" property.
		this.form = this.$form.createForm(this, { name: 'normal_login' });
	},
	mounted() {
		this.getVerCodeAsync();
	},
	methods: {
		async getVerCodeAsync() {
			try {
				const res = await vercode();
				this.ver = res.data;
			} catch (error) {
				console.log('get ver error', error);
			}
		},
		// Handles input validation after submission.
		handleSubmit(e) {
			e.preventDefault();
			this.form.validateFields(async (err, values) => {
				if (!err) {
					const res = await login({
						username: Base64.encode(values.username),
						password: Base64.encode(values.password),
						vercode: Base64.encode(values.vcode),
						vertoken: Base64.encode(this.ver.vercodeToken)
					}) || {};

					if (res.code == 0) {
						this.$store.commit('SET_TOKENS', {
							token: res.data.iToken,
							refreshToken: ''
						})
						// this.$store.commit('SET_USERNAME', '')
						// this.$store.commit('SET_USERID', '');

						//存儲登錄資訊
						const userRes = await current_user();
						if (userRes.code == 0) {
							const json = JSON.stringify(userRes.data);
							this.$store.commit('SET_CURRENT_USER', json);
						}

						window.location.href = '/';
						//this.$router.push({ path: '/' });
					} else {
						if (res.msg) {
							this.$message.error(res.msg);
							this.getVerCodeAsync();
						}
					}
				}
			});
		},
	},
})

